import { Link } from 'react-router-dom';
import styles from './DashboardModules.module.css';
import widgetStyles from './WidgetStyles.module.css';

const PublicPresenceModule = ({ isPassportComplete, publicProfiles = [] }) => {
  const profiles = publicProfiles || [];

  return (
    <div
      className={`${styles.moduleCard} ${!isPassportComplete ? styles.locked : widgetStyles.completed}`}
    >
      <div className={styles.moduleHeader}>
        <h5>Public Presence</h5>
        {isPassportComplete ? (
          <span className={`${styles.statusTag} ${styles.complete}`}>
            Ready
          </span>
        ) : (
          <span className={`${styles.statusTag} ${styles.todo}`}>Locked</span>
        )}
      </div>

      <div className={styles.moduleContent}>
        {isPassportComplete ? (
          <>
            {profiles.length > 0 ? (
              <div className={styles.emptyState}>
                <i className={`fas fa-users ${styles.emptyStateIcon}`}></i>
                <p>
                  Manage your existing Public Profiles, create a new one, or
                  generate a shareable Ego Card.
                </p>
                {/* TODO: Display a short list of existing profiles here */}
                <Link to="/profiles" className="action-button primary">
                  Go to Public Profiles
                </Link>
              </div>
            ) : (
              <div className={styles.emptyState}>
                <i
                  className={`fas fa-address-card ${styles.emptyStateIcon}`}
                ></i>
                <p>
                  Your Passport is complete! It's time to create your first
                  shareable, AI-powered Public Profile.
                </p>
                <Link to="/profiles" className="action-button primary">
                  Create a Public Profile
                </Link>
              </div>
            )}
          </>
        ) : (
          <div className={styles.emptyState}>
            <i className={`fas fa-lock ${styles.emptyStateIcon}`}></i>
            <p>
              Your AI Concierge awaits. Complete the four core Passport modules
              to unlock your Public Profiles.
            </p>
            <button className="action-button secondary" disabled>
              Create a Public Profile (Locked)
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicPresenceModule;
